// extracted by mini-css-extract-plugin
export var connectionButton = "_bl-1";
export var connectionButtonFloating = "_bl-2";
export var connectionContainer = "_bl-0";
export var rightPanel = "_bl-6";
export var stepCard = "_bl-3";
export var stepCardSubtitle = "_bl-5";
export var stepCardText = "_bl-4";